import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { IconButton } from "@/components/kit";
import { cn } from "@/lib/utils";

/** Page header: back + h1 + right-side actions (mobile Header equivalent). */
export function PageHeader({ title, eyebrow, back, right, className }) {
  const navigate = useNavigate();
  const goBack = () => (window.history.state?.idx > 0 ? navigate(-1) : navigate(back ?? "/projects"));
  return (
    <header className={cn("flex items-center gap-2 pb-6 pt-2 lg:gap-4 lg:pb-8", className)}>
      {back !== false ? (
        <IconButton icon={ChevronLeft} label="Back" onClick={goBack} data-testid="header-back-button"
          className="-ml-2 border border-transparent hover:border-border" />
      ) : null}
      <div className="min-w-0 flex-1">
        {eyebrow ? <p className="eyebrow mb-1">{eyebrow}</p> : null}
        <h1 className="truncate text-2xl font-medium tracking-tight text-foreground lg:text-3xl" data-testid="header-title">{title}</h1>
      </div>
      {right ? <div className="flex items-center gap-2">{right}</div> : null}
    </header>
  );
}

/** Glass sticky CTA bar pinned to the bottom of the content area (clears the desktop sidebar). */
export function StickyBar({ children, className }) {
  return (
    <div className="glass fixed inset-x-0 bottom-0 z-30 border-t border-border lg:left-64">
      <div className={cn("mx-auto flex w-full max-w-6xl flex-col gap-2 p-4 sm:flex-row sm:items-center sm:justify-end sm:gap-4 lg:px-10", className)}>
        {children}
      </div>
    </div>
  );
}
